/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import axios from "axios";
import { setupCache } from "axios-cache-adapter";
import React, { useEffect, useState } from "react";
import DoneIcon from "@material-ui/icons/Done";
import "./styles.scss";

interface TeamCountProps {
  countFallback: number;
}

export const TeamCount = (props: TeamCountProps): JSX.Element => {
  const { countFallback } = props;
  const [teamCount, setTeamCount] = useState(0);
  const cache = setupCache({
    maxAge: 15 * 60 * 1000,
  });
  const api = axios.create({
    adapter: cache.adapter,
  });
  useEffect(() => {
    api
      .get("https://api.igem.io/api/openingWeekend/numberOfTeams")
      .then((value) => setTeamCount(value.data.data.totalNumberOfTeams))
      .catch(() => setTeamCount(countFallback ?? 0));
  }, []);
  return (
    <div className="tcc">
      <div className="tcc-title">
        <h1>{teamCount}</h1>
        <div>
          <DoneIcon />
        </div>
      </div>
      <p>
        teams have registered for
        <br />
        the iGEM 2021 Competition
      </p>
    </div>
  );
};
